import { render, staticRenderFns } from "./firstTag.vue?vue&type=template&id=0f0de83a&scoped=true&"
import script from "./firstTag.vue?vue&type=script&lang=js&"
export * from "./firstTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0de83a",
  null
  
)

export default component.exports